<template>
   <!-- Page Content -->
        <div id='page-wrapper'>
          <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
            <div class='container-fluid'>
                <div class='row'>
                    <div class='col-lg-12'>
                        <h1 class='page-header'>السلف</h1>
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
                <!-- /.row -->
                <div class='row'>
                    <div class='col-lg-12'>
                        <div class='panel panel-default'>
                            <div class='panel-heading'>
                              هنا يتم عرض جميع السلف [{{total}}]
                                <div v-show="$per.value.saveAdvance" class='pull-left' style='padding=0px'>
                                    <button @click='showForm(0)' type='button' class='btn btn-outline btn-primary btn-sm ' style='padding:3px;width: 80px' data-toggle='modal' data-target='#myModal'>
                                      <b>  إضافة جديد </b>
                                    </button>
                                </div>
                              </div>
                              <!-- /.panel-heading -->
                              <div class='panel-body'>
                              <div class='row'>
                                    <div class='col-lg-3 col-sm-3'>
                                      <div class="form-group input-group">
                                        <span class="input-group-addon" style='padding:5px;'>الفرع:</span>
                                        <select @change='GetEmp()' class="form-control" v-model="filterBranche" style="padding: 0px">
                                          <option v-for="item in branches" :key="item.id" v-bind:value="item.id">
                                            {{ item.name }}
                                          </option>
                                        </select>
                                      </div>
                                    </div>
                                    <div class='col-lg-5 col-sm-5'>
                                      <div class="form-group input-group">
                                        <span class="input-group-addon" style='padding:5px;'>الموظف:</span>
                                        <select class="form-control" v-model="filterEmp" style="padding: 0px">
                                          <option v-for="item in emps" :key="item.id" v-bind:value="item.id">
                                            {{ item.name }}
                                          </option>
                                        </select>
                                      </div>
                                    </div>
                              <div class='col-lg-2 col-sm-2'>
                                <div class="form-group input-group">
                                  <span class="input-group-addon" style='padding:5px;'>الشهر:</span>
                                  <Datepicker :typeable="true" :maximum-view="'year'" :minimum-view="'month'" :format="customMonthFormatter" :language="ar" :bootstrap-styling="true" v-model='xDate'></Datepicker>
                                </div>
                              </div>
                                <div class='form-group col-lg-2 col-sm-2'>
                                  <button @click='search' type='button' class='btn btn-primary btn-block'>عرض</button>
                                </div>
                            </div>
                                <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                                    <thead>
                                      <tr>

                                          <th style='text-align: center'>الموظف</th>
                                          <th style='text-align: center'>المبلغ</th>
                                          <th style='text-align: center'>التاريخ</th>
                                          <th style='text-align: center'>ملاحظات</th>
                                          <th style='text-align: center'>الاجراء</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                        <tr class='odd gradeX' v-for='record in records' :key='record.id'>

                                          <td align='center'>{{record.name}}</td>
                                          <td align='center'>{{record.amount}}</td>
                                          <td align='center'>{{record.date}}</td>
                                          <td align='center'>{{record.notes}}</td>
                                          <td align='center'>
                                              <vue-element-loading size='32' :active='isLoadingDelete' spinner='bar-fade-scale' color='#A4A4A4'/>
                                              <button v-show="$per.value.deleteAdvance" @click='deleteData(record.id)' type='button' class='btn btn-outline btn-danger btn-xs'>حذف</button>
                                              <button v-show="$per.value.editAdvance" @click='showForm(record)' type='button' class='btn btn-outline btn-info btn-xs' data-toggle='modal' data-target='#myModal'>تعديل</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <!-- /.table-responsive -->
                            </div>
                            <!-- /.panel-body -->
                        </div>
                        <!-- /.panel -->
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
             </div>
             <!-- Modal -->
             <div class='modal fade' id='myModal' tabindex='-1' role='dialog'  aria-labelledby='myModalLabel'>
                 <div class='modal-dialog  modal-md'>
                     <div class='modal-content'>
                         <div class='modal-header'>
                             <button type='button' class='close' data-dismiss='modal' aria-hidden='true'>&times;</button>
                             <h4 class='modal-title' id='myModalLabel'>{{title}}</h4>
                         </div>
                         <form role='form'>
                         <div class='modal-body'>
                           <div class='alert alert-danger alert-dismissable' v-if='errorShow'>
                             <ul v-if='validationErrors'>
                                 <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                             </ul>
                           </div>
                           <div class='alert alert-success alert-dismissable' v-if='successShow'>
                              {{success}}
                           </div>
                           <fieldset>
                             <div class='col-lg-6 col-sm-6'>
                               <div class="form-group input-group">
                                 <span class="input-group-addon" style='padding:5px;'>الموظف:</span>
                                 <select class="form-control"  v-model="record.emp_id" style='padding: 0px'>
                                   <option v-for="item in emps" v-bind:key="item.id" v-bind:value="item.id">
                                     {{ item.name }}
                                   </option>
                                 </select>
                               </div>
                             </div>
                             <div class='col-lg-6 col-sm-6'>
                               <div class="form-group input-group">
                                 <span class="input-group-addon" style='padding:5px;'>الخزنة:</span>
                                 <select class="form-control" style="padding: 0px" v-model="record.treasury_id">
                                   <option v-for="treasury in treasuries" v-bind:key="treasury.id" v-bind:value="treasury.id">
                                     {{ treasury.name }}
                                   </option>
                                 </select>
                               </div>
                             </div>
                                 <div class='col-lg-3 col-sm-3' style="padding: 0px 15px 0px 5px">
                                   <div class="form-group input-group">
                                     <span class="input-group-addon" style='padding:5px;'>المبلغ:</span>
                                     <input  style="padding: 10px 8px" v-model='record.amount' class='form-control' name='amount' type='text'>
                                   </div>
                                 </div>
                                 <div class='col-lg-5 col-sm-5' style="padding: 0px 5px">
                                   <div class="form-group input-group">
                                     <span class="input-group-addon" style='padding:5px;'>تاريخ السلفة:</span>
                                     <Datepicker :typeable="true" :format="customFormatter" :language="ar" :bootstrap-styling="true" v-model='record.date'></Datepicker>
                                   </div>
                                 </div>
                                 <div class='col-lg-4 col-sm-4' style="padding: 0px 5px 0px 15px">
                                   <div class="form-group input-group">
                                     <span class="input-group-addon" style='padding:5px;'>الشهر:</span>
                                     <Datepicker :typeable="true" :maximum-view="'year'" :minimum-view="'month'" :format="customMonthFormatter" :language="ar" :bootstrap-styling="true" v-model='record.month'></Datepicker>
                                   </div>
                                 </div>
                                 <div class='col-lg-12 col-sm-12'>
                                   <div class="form-group input-group">
                                     <span class="input-group-addon" style='padding:5px;'>ملاحظات:</span>
                                     <input v-model='record.notes' class='form-control' name='notes' type='text'>
                                   </div>
                                 </div>
                               </fieldset>
                           </div>
                           <div class='modal-footer'>
                               <button type='button' class='btn btn-default' data-dismiss='modal'>خروج</button>
                               <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
                               <button @click='saveData' type='button' class='btn btn-primary'>حفظ</button>
                           </div>
                         </form>
                     </div>
                     <!-- /.modal-content -->
                 </div>
                 <!-- /.modal-dialog -->
             </div>
             <!-- /.modal -->
             <!-- /.container-fluid -->
        </div>
</template>
<script>
import axios from 'axios'
import tbDate from '@/components/myComponents/tbDate'
import Swal from 'sweetalert2'
import Datepicker from 'vuejs-datepicker'
import {ar} from 'vuejs-datepicker/dist/locale'
import moment from 'moment'
export default {
  components: {
    tbDate,
    Datepicker
  },
  name: 'advance',
  data () {
    return {
      xDate: '',
      ar: ar,
      dateTitle: 'التاريخ:',
      monthTitle: 'الشهر: شهر-سنة:',
      mytype: 'month',
      total: 0,
      today: true,
      branches: [],
      treasuries: [],
      emps: {},
      filterEmps: {},
      filterEmp: 0,
      validationErrors: '',
      records: [],
      record: {},
      errorShow: false,
      successShow: false,
      isLoadingData: false,
      isLoadingSave: false,
      isLoadingDelete: false,
      filterBranche: '',
      title: ''
    }
  },
  created () {
    const now = new Date()
    this.xDate = new Date(now.getFullYear(), now.getMonth(), 1)
    this.branches = JSON.parse(localStorage.getItem('Branches'))
    this.record.branche_id = this.branches[0].id
    this.filterBranche = localStorage.getItem('BrancheID')
    this.GetEmp()
  },
  methods: {
    // =====================================================
    GetEmp () {
      this.isLoadingData = true
      this.record.branche_id = this.filterBranche
      axios.post(this.$apiURL + 'getBranchEmp', {
        token: localStorage.getItem('token'),
        branch_id: this.record.branche_id
      })
        .then(({ data }) => {
          this.emps = data
          this.filterEmps = data
          let emptyRec = [{id: 0, name: ''}]
          this.filterEmps.unshift(emptyRec)
          this.filterEmp = 0
          let i = this.branches.findIndex(x => x.id === parseInt(this.record.branche_id))
          if (i > -1) {
            this.treasuries = this.branches[i].treasuries
          }
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    },
    // =====================================================
    customFormatter (date) {
      return moment(date).format('YYYY-MM-DD')
    },
    // =====================================================
    customMonthFormatter (date) {
      return moment(date).format('YYYY-MM')
    },
    // =====================================================
    isNumber: function (evt) {
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    // =====================================================
    search () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getAdvance', {
        token: localStorage.getItem('token'),
        branche_id: this.filterBranche,
        Emp: this.filterEmp,
        month: this.formatDateForApi(this.xDate),
        type: this.filterType
      })
        .then(({ data }) => {
          this.isLoadingData = false
          this.records = data
          this.total = 0
          for (let i in data) { this.total += data[i].amount }
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    },
    showForm (recID) {
      this.errorShow = false
      this.successShow = false
      this.error = ''
      if (recID === 0) {
        this.title = 'إضافة سجل جديد'
        this.record = {'id': 0, 'branche_id': this.record.branche_id, 'emp_id': '', 'treasury_id': '', 'amount': '', 'month': '', 'notes': ''}
        const now = new Date()
        this.record.date = new Date(now.getFullYear(), now.getMonth(), now.getDate())
        this.record.month = new Date(now.getFullYear(), now.getMonth(), 1)
      } else {
        this.title = 'تعديل بيانات سجل'
        this.record = recID
      }
    },
    // =========================================================
    formatDateForApi (date) {
      if (!date) return null

      const d = new Date(date)
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')

      return `${y}-${m}-${day}`
    },
    // =========================================================
    saveData () {
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'saveAdvance', {
        token: localStorage.getItem('token'),
        id: this.record.id,
        uid: this.record.uid,
        branche_id: this.record.branche_id,
        emp_id: this.record.emp_id,
        treasury_id: this.record.treasury_id,
        amount: this.record.amount,
        month: this.formatDateForApi(this.record.month),
        notes: this.record.notes,
        date: this.formatDateForApi(this.record.date)
      })
        .then(res => {
          this.isLoadingSave = false
          if (this.record.id === 0) {
            this.records.push(res.data)
            this.success = 'تم الحفظ بنجاح'
            this.successShow = true
            this.errorShow = false
          } else {
            let i = this.records.map(record => record.id).indexOf(this.record.id)
            this.records.splice(i, 1, res.data)
            this.success = 'تم الحفظ بنجاح'
            this.successShow = true
            this.errorShow = false
          }
        })
        .catch(err => {
          console.log(err)
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingSave = false
        })
    },
    deleteData (recID) {
      Swal.fire({
        title: 'هل أنت متأكد',
        text: 'سيتم حذف هذا السجل نهائيا من قاعدة البيانات!',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#3085d6',
        confirmButtonColor: '#d33',
        cancelButtonText: 'لا',
        confirmButtonText: 'نعم'
      }).then((result) => {
        if (result.isConfirmed) {
          this.isLoadingDelete = true
          axios.post(this.$apiURL + 'deleteAdvance', {
            token: localStorage.getItem('token'),
            id: recID
          })
            .then(res => {
              let i = this.records.map(record => record.id).indexOf(recID)
              this.records.splice(i, 1)
              this.isLoadingDelete = false
            })
            .catch(err => {
              if (err.response.data.errors === 'Unauthenticated') {
                this.$router.push('login')
              }
              if (err.response.data.errors === 'Forbidden') {
                this.$router.push('accessdeny')
              }
              this.error = err.message
              this.isLoadingDelete = false
            })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/employees/Advances.vue